import React from "react";

const DynamicSvgComponent = ({ svgFilename }) => (
  <img src={`/platform/${svgFilename}.svg`} alt={svgFilename} />
);

export default DynamicSvgComponent;